module.exports = __webpack_public_path__ + "static/techorama-c8a62b958ce47211dba3c10a8fa7945f.jpeg";